import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processCarPoolingData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
  remarks: Remark[],
): BinderSectionData => {
  const processedCarPoolingData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const isCarPooling =
        vehicle?.is_car_pooling !== undefined ? vehicle.is_car_pooling : false;

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        isCarPooling,
        isValid: !isCarPooling,
        remarks: remarks.find((r) => r.item_key === `vehicle-${index + 1}`)
          ?.text,
      };
    }),
  };

  // Overall car pooling validation
  const isCarPoolingValid = processedCarPoolingData.vehicles.every(
    (vehicle) => vehicle.isValid,
  );
  const carPoolingMessage = !isCarPoolingValid
    ? 'One or more vehicles are used for car pooling'
    : null;

  return {
    title: 'Car pooling',
    description: 'Are any vehicles on the application used for car pooling?',
    isValid: isCarPoolingValid,
    message: carPoolingMessage,
    data: processedCarPoolingData,
  };
};
